import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\Admin\Rooms\RoomController::index
* @see app/Http/Controllers/Admin/Rooms/RoomController.php:38
* @route '/rooms'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/rooms',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\Rooms\RoomController::index
* @see app/Http/Controllers/Admin/Rooms/RoomController.php:38
* @route '/rooms'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Rooms\RoomController::index
* @see app/Http/Controllers/Admin/Rooms/RoomController.php:38
* @route '/rooms'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Rooms\RoomController::index
* @see app/Http/Controllers/Admin/Rooms/RoomController.php:38
* @route '/rooms'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\Rooms\RoomController::index
* @see app/Http/Controllers/Admin/Rooms/RoomController.php:38
* @route '/rooms'
*/
const indexForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Rooms\RoomController::index
* @see app/Http/Controllers/Admin/Rooms/RoomController.php:38
* @route '/rooms'
*/
indexForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Rooms\RoomController::index
* @see app/Http/Controllers/Admin/Rooms/RoomController.php:38
* @route '/rooms'
*/
indexForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

index.form = indexForm

/**
* @see \App\Http\Controllers\Admin\Rooms\RoomController::create
* @see app/Http/Controllers/Admin/Rooms/RoomController.php:340
* @route '/rooms/create'
*/
export const create = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: create.url(options),
    method: 'get',
})

create.definition = {
    methods: ["get","head"],
    url: '/rooms/create',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\Rooms\RoomController::create
* @see app/Http/Controllers/Admin/Rooms/RoomController.php:340
* @route '/rooms/create'
*/
create.url = (options?: RouteQueryOptions) => {
    return create.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Rooms\RoomController::create
* @see app/Http/Controllers/Admin/Rooms/RoomController.php:340
* @route '/rooms/create'
*/
create.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: create.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Rooms\RoomController::create
* @see app/Http/Controllers/Admin/Rooms/RoomController.php:340
* @route '/rooms/create'
*/
create.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: create.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\Rooms\RoomController::create
* @see app/Http/Controllers/Admin/Rooms/RoomController.php:340
* @route '/rooms/create'
*/
const createForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Rooms\RoomController::create
* @see app/Http/Controllers/Admin/Rooms/RoomController.php:340
* @route '/rooms/create'
*/
createForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Rooms\RoomController::create
* @see app/Http/Controllers/Admin/Rooms/RoomController.php:340
* @route '/rooms/create'
*/
createForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

create.form = createForm

/**
* @see \App\Http\Controllers\Admin\Rooms\RoomController::markCleaning
* @see app/Http/Controllers/Admin/Rooms/RoomController.php:962
* @route '/rooms/mark-cleaning'
*/
export const markCleaning = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: markCleaning.url(options),
    method: 'post',
})

markCleaning.definition = {
    methods: ["post"],
    url: '/rooms/mark-cleaning',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\Rooms\RoomController::markCleaning
* @see app/Http/Controllers/Admin/Rooms/RoomController.php:962
* @route '/rooms/mark-cleaning'
*/
markCleaning.url = (options?: RouteQueryOptions) => {
    return markCleaning.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Rooms\RoomController::markCleaning
* @see app/Http/Controllers/Admin/Rooms/RoomController.php:962
* @route '/rooms/mark-cleaning'
*/
markCleaning.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: markCleaning.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Rooms\RoomController::markCleaning
* @see app/Http/Controllers/Admin/Rooms/RoomController.php:962
* @route '/rooms/mark-cleaning'
*/
const markCleaningForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: markCleaning.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Rooms\RoomController::markCleaning
* @see app/Http/Controllers/Admin/Rooms/RoomController.php:962
* @route '/rooms/mark-cleaning'
*/
markCleaningForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: markCleaning.url(options),
    method: 'post',
})

markCleaning.form = markCleaningForm

/**
* @see \App\Http\Controllers\Admin\Rooms\RoomController::markOutOfOrder
* @see app/Http/Controllers/Admin/Rooms/RoomController.php:999
* @route '/rooms/mark-out-of-order'
*/
export const markOutOfOrder = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: markOutOfOrder.url(options),
    method: 'post',
})

markOutOfOrder.definition = {
    methods: ["post"],
    url: '/rooms/mark-out-of-order',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\Rooms\RoomController::markOutOfOrder
* @see app/Http/Controllers/Admin/Rooms/RoomController.php:999
* @route '/rooms/mark-out-of-order'
*/
markOutOfOrder.url = (options?: RouteQueryOptions) => {
    return markOutOfOrder.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Rooms\RoomController::markOutOfOrder
* @see app/Http/Controllers/Admin/Rooms/RoomController.php:999
* @route '/rooms/mark-out-of-order'
*/
markOutOfOrder.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: markOutOfOrder.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Rooms\RoomController::markOutOfOrder
* @see app/Http/Controllers/Admin/Rooms/RoomController.php:999
* @route '/rooms/mark-out-of-order'
*/
const markOutOfOrderForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: markOutOfOrder.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Rooms\RoomController::markOutOfOrder
* @see app/Http/Controllers/Admin/Rooms/RoomController.php:999
* @route '/rooms/mark-out-of-order'
*/
markOutOfOrderForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: markOutOfOrder.url(options),
    method: 'post',
})

markOutOfOrder.form = markOutOfOrderForm

/**
* @see \App\Http\Controllers\Admin\Rooms\RoomController::removeCleaning
* @see app/Http/Controllers/Admin/Rooms/RoomController.php:1071
* @route '/rooms/remove-cleaning'
*/
export const removeCleaning = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: removeCleaning.url(options),
    method: 'post',
})

removeCleaning.definition = {
    methods: ["post"],
    url: '/rooms/remove-cleaning',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\Rooms\RoomController::removeCleaning
* @see app/Http/Controllers/Admin/Rooms/RoomController.php:1071
* @route '/rooms/remove-cleaning'
*/
removeCleaning.url = (options?: RouteQueryOptions) => {
    return removeCleaning.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Rooms\RoomController::removeCleaning
* @see app/Http/Controllers/Admin/Rooms/RoomController.php:1071
* @route '/rooms/remove-cleaning'
*/
removeCleaning.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: removeCleaning.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Rooms\RoomController::removeCleaning
* @see app/Http/Controllers/Admin/Rooms/RoomController.php:1071
* @route '/rooms/remove-cleaning'
*/
const removeCleaningForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: removeCleaning.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Rooms\RoomController::removeCleaning
* @see app/Http/Controllers/Admin/Rooms/RoomController.php:1071
* @route '/rooms/remove-cleaning'
*/
removeCleaningForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: removeCleaning.url(options),
    method: 'post',
})

removeCleaning.form = removeCleaningForm

/**
* @see \App\Http\Controllers\Admin\Rooms\RoomController::reorder
* @see app/Http/Controllers/Admin/Rooms/RoomController.php:781
* @route '/rooms/reorder'
*/
export const reorder = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: reorder.url(options),
    method: 'post',
})

reorder.definition = {
    methods: ["post"],
    url: '/rooms/reorder',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\Rooms\RoomController::reorder
* @see app/Http/Controllers/Admin/Rooms/RoomController.php:781
* @route '/rooms/reorder'
*/
reorder.url = (options?: RouteQueryOptions) => {
    return reorder.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Rooms\RoomController::reorder
* @see app/Http/Controllers/Admin/Rooms/RoomController.php:781
* @route '/rooms/reorder'
*/
reorder.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: reorder.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Rooms\RoomController::reorder
* @see app/Http/Controllers/Admin/Rooms/RoomController.php:781
* @route '/rooms/reorder'
*/
const reorderForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: reorder.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Rooms\RoomController::reorder
* @see app/Http/Controllers/Admin/Rooms/RoomController.php:781
* @route '/rooms/reorder'
*/
reorderForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: reorder.url(options),
    method: 'post',
})

reorder.form = reorderForm

/**
* @see \App\Http\Controllers\Admin\Rooms\RoomController::bulkStore
* @see app/Http/Controllers/Admin/Rooms/RoomController.php:528
* @route '/rooms/bulk'
*/
export const bulkStore = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: bulkStore.url(options),
    method: 'post',
})

bulkStore.definition = {
    methods: ["post"],
    url: '/rooms/bulk',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\Rooms\RoomController::bulkStore
* @see app/Http/Controllers/Admin/Rooms/RoomController.php:528
* @route '/rooms/bulk'
*/
bulkStore.url = (options?: RouteQueryOptions) => {
    return bulkStore.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Rooms\RoomController::bulkStore
* @see app/Http/Controllers/Admin/Rooms/RoomController.php:528
* @route '/rooms/bulk'
*/
bulkStore.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: bulkStore.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Rooms\RoomController::bulkStore
* @see app/Http/Controllers/Admin/Rooms/RoomController.php:528
* @route '/rooms/bulk'
*/
const bulkStoreForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: bulkStore.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Rooms\RoomController::bulkStore
* @see app/Http/Controllers/Admin/Rooms/RoomController.php:528
* @route '/rooms/bulk'
*/
bulkStoreForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: bulkStore.url(options),
    method: 'post',
})

bulkStore.form = bulkStoreForm

/**
* @see \App\Http\Controllers\Admin\Rooms\RoomController::store
* @see app/Http/Controllers/Admin/Rooms/RoomController.php:385
* @route '/rooms'
*/
export const store = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/rooms',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\Rooms\RoomController::store
* @see app/Http/Controllers/Admin/Rooms/RoomController.php:385
* @route '/rooms'
*/
store.url = (options?: RouteQueryOptions) => {
    return store.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Rooms\RoomController::store
* @see app/Http/Controllers/Admin/Rooms/RoomController.php:385
* @route '/rooms'
*/
store.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Rooms\RoomController::store
* @see app/Http/Controllers/Admin/Rooms/RoomController.php:385
* @route '/rooms'
*/
const storeForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Rooms\RoomController::store
* @see app/Http/Controllers/Admin/Rooms/RoomController.php:385
* @route '/rooms'
*/
storeForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

store.form = storeForm

/**
* @see \App\Http\Controllers\Admin\Rooms\RoomController::card
* @see app/Http/Controllers/Admin/Rooms/RoomController.php:169
* @route '/rooms/{room}/card'
*/
export const card = (args: { room: string | { id: string } } | [room: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: card.url(args, options),
    method: 'get',
})

card.definition = {
    methods: ["get","head"],
    url: '/rooms/{room}/card',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\Rooms\RoomController::card
* @see app/Http/Controllers/Admin/Rooms/RoomController.php:169
* @route '/rooms/{room}/card'
*/
card.url = (args: { room: string | { id: string } } | [room: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { room: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { room: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            room: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        room: typeof args.room === 'object'
        ? args.room.id
        : args.room,
    }

    return card.definition.url
            .replace('{room}', parsedArgs.room.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Rooms\RoomController::card
* @see app/Http/Controllers/Admin/Rooms/RoomController.php:169
* @route '/rooms/{room}/card'
*/
card.get = (args: { room: string | { id: string } } | [room: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: card.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Rooms\RoomController::card
* @see app/Http/Controllers/Admin/Rooms/RoomController.php:169
* @route '/rooms/{room}/card'
*/
card.head = (args: { room: string | { id: string } } | [room: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: card.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\Rooms\RoomController::card
* @see app/Http/Controllers/Admin/Rooms/RoomController.php:169
* @route '/rooms/{room}/card'
*/
const cardForm = (args: { room: string | { id: string } } | [room: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: card.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Rooms\RoomController::card
* @see app/Http/Controllers/Admin/Rooms/RoomController.php:169
* @route '/rooms/{room}/card'
*/
cardForm.get = (args: { room: string | { id: string } } | [room: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: card.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Rooms\RoomController::card
* @see app/Http/Controllers/Admin/Rooms/RoomController.php:169
* @route '/rooms/{room}/card'
*/
cardForm.head = (args: { room: string | { id: string } } | [room: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: card.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

card.form = cardForm

/**
* @see \App\Http\Controllers\Admin\Rooms\RoomController::show
* @see app/Http/Controllers/Admin/Rooms/RoomController.php:184
* @route '/rooms/{room}'
*/
export const show = (args: { room: string | number } | [room: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

show.definition = {
    methods: ["get","head"],
    url: '/rooms/{room}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\Rooms\RoomController::show
* @see app/Http/Controllers/Admin/Rooms/RoomController.php:184
* @route '/rooms/{room}'
*/
show.url = (args: { room: string | number } | [room: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { room: args }
    }

    if (Array.isArray(args)) {
        args = {
            room: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        room: args.room,
    }

    return show.definition.url
            .replace('{room}', parsedArgs.room.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Rooms\RoomController::show
* @see app/Http/Controllers/Admin/Rooms/RoomController.php:184
* @route '/rooms/{room}'
*/
show.get = (args: { room: string | number } | [room: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Rooms\RoomController::show
* @see app/Http/Controllers/Admin/Rooms/RoomController.php:184
* @route '/rooms/{room}'
*/
show.head = (args: { room: string | number } | [room: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: show.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\Rooms\RoomController::show
* @see app/Http/Controllers/Admin/Rooms/RoomController.php:184
* @route '/rooms/{room}'
*/
const showForm = (args: { room: string | number } | [room: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Rooms\RoomController::show
* @see app/Http/Controllers/Admin/Rooms/RoomController.php:184
* @route '/rooms/{room}'
*/
showForm.get = (args: { room: string | number } | [room: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Rooms\RoomController::show
* @see app/Http/Controllers/Admin/Rooms/RoomController.php:184
* @route '/rooms/{room}'
*/
showForm.head = (args: { room: string | number } | [room: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

show.form = showForm

/**
* @see \App\Http\Controllers\Admin\Rooms\RoomController::edit
* @see app/Http/Controllers/Admin/Rooms/RoomController.php:641
* @route '/rooms/{room}/edit'
*/
export const edit = (args: { room: string | number } | [room: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: edit.url(args, options),
    method: 'get',
})

edit.definition = {
    methods: ["get","head"],
    url: '/rooms/{room}/edit',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\Rooms\RoomController::edit
* @see app/Http/Controllers/Admin/Rooms/RoomController.php:641
* @route '/rooms/{room}/edit'
*/
edit.url = (args: { room: string | number } | [room: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { room: args }
    }

    if (Array.isArray(args)) {
        args = {
            room: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        room: args.room,
    }

    return edit.definition.url
            .replace('{room}', parsedArgs.room.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Rooms\RoomController::edit
* @see app/Http/Controllers/Admin/Rooms/RoomController.php:641
* @route '/rooms/{room}/edit'
*/
edit.get = (args: { room: string | number } | [room: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: edit.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Rooms\RoomController::edit
* @see app/Http/Controllers/Admin/Rooms/RoomController.php:641
* @route '/rooms/{room}/edit'
*/
edit.head = (args: { room: string | number } | [room: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: edit.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\Rooms\RoomController::edit
* @see app/Http/Controllers/Admin/Rooms/RoomController.php:641
* @route '/rooms/{room}/edit'
*/
const editForm = (args: { room: string | number } | [room: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: edit.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Rooms\RoomController::edit
* @see app/Http/Controllers/Admin/Rooms/RoomController.php:641
* @route '/rooms/{room}/edit'
*/
editForm.get = (args: { room: string | number } | [room: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: edit.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Rooms\RoomController::edit
* @see app/Http/Controllers/Admin/Rooms/RoomController.php:641
* @route '/rooms/{room}/edit'
*/
editForm.head = (args: { room: string | number } | [room: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: edit.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

edit.form = editForm

/**
* @see \App\Http\Controllers\Admin\Rooms\RoomController::update
* @see app/Http/Controllers/Admin/Rooms/RoomController.php:716
* @route '/rooms/{room}'
*/
export const update = (args: { room: string | number } | [room: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

update.definition = {
    methods: ["put"],
    url: '/rooms/{room}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Admin\Rooms\RoomController::update
* @see app/Http/Controllers/Admin/Rooms/RoomController.php:716
* @route '/rooms/{room}'
*/
update.url = (args: { room: string | number } | [room: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { room: args }
    }

    if (Array.isArray(args)) {
        args = {
            room: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        room: args.room,
    }

    return update.definition.url
            .replace('{room}', parsedArgs.room.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Rooms\RoomController::update
* @see app/Http/Controllers/Admin/Rooms/RoomController.php:716
* @route '/rooms/{room}'
*/
update.put = (args: { room: string | number } | [room: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\Admin\Rooms\RoomController::update
* @see app/Http/Controllers/Admin/Rooms/RoomController.php:716
* @route '/rooms/{room}'
*/
const updateForm = (args: { room: string | number } | [room: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Rooms\RoomController::update
* @see app/Http/Controllers/Admin/Rooms/RoomController.php:716
* @route '/rooms/{room}'
*/
updateForm.put = (args: { room: string | number } | [room: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

update.form = updateForm

/**
* @see \App\Http\Controllers\Admin\Rooms\RoomController::destroy
* @see app/Http/Controllers/Admin/Rooms/RoomController.php:822
* @route '/rooms/{room}'
*/
export const destroy = (args: { room: string | number } | [room: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '/rooms/{room}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Admin\Rooms\RoomController::destroy
* @see app/Http/Controllers/Admin/Rooms/RoomController.php:822
* @route '/rooms/{room}'
*/
destroy.url = (args: { room: string | number } | [room: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { room: args }
    }

    if (Array.isArray(args)) {
        args = {
            room: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        room: args.room,
    }

    return destroy.definition.url
            .replace('{room}', parsedArgs.room.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Rooms\RoomController::destroy
* @see app/Http/Controllers/Admin/Rooms/RoomController.php:822
* @route '/rooms/{room}'
*/
destroy.delete = (args: { room: string | number } | [room: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\Admin\Rooms\RoomController::destroy
* @see app/Http/Controllers/Admin/Rooms/RoomController.php:822
* @route '/rooms/{room}'
*/
const destroyForm = (args: { room: string | number } | [room: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Rooms\RoomController::destroy
* @see app/Http/Controllers/Admin/Rooms/RoomController.php:822
* @route '/rooms/{room}'
*/
destroyForm.delete = (args: { room: string | number } | [room: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

destroy.form = destroyForm

/**
* @see \App\Http\Controllers\Admin\Rooms\RoomController::upcomingBookings
* @see app/Http/Controllers/Admin/Rooms/RoomController.php:859
* @route '/rooms/{room}/upcoming-bookings'
*/
export const upcomingBookings = (args: { room: string | number } | [room: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: upcomingBookings.url(args, options),
    method: 'get',
})

upcomingBookings.definition = {
    methods: ["get","head"],
    url: '/rooms/{room}/upcoming-bookings',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\Rooms\RoomController::upcomingBookings
* @see app/Http/Controllers/Admin/Rooms/RoomController.php:859
* @route '/rooms/{room}/upcoming-bookings'
*/
upcomingBookings.url = (args: { room: string | number } | [room: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { room: args }
    }

    if (Array.isArray(args)) {
        args = {
            room: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        room: args.room,
    }

    return upcomingBookings.definition.url
            .replace('{room}', parsedArgs.room.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Rooms\RoomController::upcomingBookings
* @see app/Http/Controllers/Admin/Rooms/RoomController.php:859
* @route '/rooms/{room}/upcoming-bookings'
*/
upcomingBookings.get = (args: { room: string | number } | [room: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: upcomingBookings.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Rooms\RoomController::upcomingBookings
* @see app/Http/Controllers/Admin/Rooms/RoomController.php:859
* @route '/rooms/{room}/upcoming-bookings'
*/
upcomingBookings.head = (args: { room: string | number } | [room: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: upcomingBookings.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\Rooms\RoomController::upcomingBookings
* @see app/Http/Controllers/Admin/Rooms/RoomController.php:859
* @route '/rooms/{room}/upcoming-bookings'
*/
const upcomingBookingsForm = (args: { room: string | number } | [room: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: upcomingBookings.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Rooms\RoomController::upcomingBookings
* @see app/Http/Controllers/Admin/Rooms/RoomController.php:859
* @route '/rooms/{room}/upcoming-bookings'
*/
upcomingBookingsForm.get = (args: { room: string | number } | [room: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: upcomingBookings.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Rooms\RoomController::upcomingBookings
* @see app/Http/Controllers/Admin/Rooms/RoomController.php:859
* @route '/rooms/{room}/upcoming-bookings'
*/
upcomingBookingsForm.head = (args: { room: string | number } | [room: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: upcomingBookings.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

upcomingBookings.form = upcomingBookingsForm

const rooms = {
    index: Object.assign(index, index),
    create: Object.assign(create, create),
    markCleaning: Object.assign(markCleaning, markCleaning),
    markOutOfOrder: Object.assign(markOutOfOrder, markOutOfOrder),
    removeCleaning: Object.assign(removeCleaning, removeCleaning),
    reorder: Object.assign(reorder, reorder),
    bulkStore: Object.assign(bulkStore, bulkStore),
    store: Object.assign(store, store),
    card: Object.assign(card, card),
    show: Object.assign(show, show),
    edit: Object.assign(edit, edit),
    update: Object.assign(update, update),
    destroy: Object.assign(destroy, destroy),
    upcomingBookings: Object.assign(upcomingBookings, upcomingBookings),
}

export default rooms